import React from 'react';
import { CompetitionRole, ROLE_LABELS } from '../../services/manageApi';

interface ReadOnlyFieldProps {
  label: string;
  value?: React.ReactNode;
  /** Who can change it; shown as "🔒 <role>". */
  requiredRole?: CompetitionRole;
  note?: string;
}

const ReadOnlyField: React.FC<ReadOnlyFieldProps> = ({ label, value, requiredRole, note }) => (
  <div className="manage-field manage-field--readonly">
    <span className="manage-field__label">
      {label}
      {requiredRole && <span className="manage-field__lock">🔒 {ROLE_LABELS[requiredRole]}</span>}
      {note && <span className="manage-field__note">{note}</span>}
    </span>
    <div className="manage-field__value">
      {value === undefined || value === null || value === '' ? '—' : value}
    </div>
  </div>
);

export default ReadOnlyField;
